import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2478d222")

_pushScopeId("data-v-2478d222")
const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = {
  key: 0,
  class: "project-list"
}
const _hoisted_3 = { class: "nested-list" }
const _hoisted_4 = { class: "year-category" }
const _hoisted_5 = { class: "section-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AppNavigationSidebar = _resolveComponent("AppNavigationSidebar")!
  const _component_AppNavigationRouterLink = _resolveComponent("AppNavigationRouterLink")!
  const _directive_body_scroll_lock = _resolveDirective("body-scroll-lock")!

  return _withDirectives((_openBlock(), _createBlock("nav", {
    class: ["app-navigation", { active: _ctx.isOpen }]
  }, [
    _createVNode(_component_AppNavigationSidebar, {
      isOpen: _ctx.isOpen,
      onToggleNavigation: _ctx.toggleNavigation
    }, null, 8, ["isOpen", "onToggleNavigation"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock("ul", _hoisted_2, [
            (_ctx.landingRoute)
              ? (_openBlock(), _createBlock(_component_AppNavigationRouterLink, {
                  key: 0,
                  path: _ctx.landingRoute.path,
                  routeName: _ctx.landingRoute.name?.toString() ?? '',
                  onCloseNavigation: _ctx.closeNavigation
                }, null, 8, ["path", "routeName", "onCloseNavigation"]))
              : _createCommentVNode("", true),
            _createVNode("li", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aggregatedProjectRoutesByCreatedOn, ([year, routes]) => {
                return (_openBlock(), _createBlock("ul", _hoisted_4, [
                  _createVNode("li", _hoisted_5, _toDisplayString(year), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(routes, ({ path, name, meta }) => {
                    return (_openBlock(), _createBlock(_component_AppNavigationRouterLink, {
                      desktopOnly: meta?.desktopOnly,
                      path: path,
                      routeName: name?.toString() ?? '',
                      key: `${year} ${name?.toString() ?? ''}`,
                      onCloseNavigation: _ctx.closeNavigation
                    }, null, 8, ["desktopOnly", "path", "routeName", "onCloseNavigation"]))
                  }), 128))
                ]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2)), [
    [_directive_body_scroll_lock, _ctx.isOpen]
  ])
})